<template>
    <form @submit.prevent="submit">
        <FormGroup name="email" label="Email">
            <Input
                name="email"
                type="email"
                v-model="form.email"
                required
                disabled
                readonly/>
        </FormGroup>

        <FormGroup name="password" label="Password">
            <Input
                ref="password"
                name="password"
                type="password"
                v-model="form.password"
                required
                autocomplete="new-password"/>
        </FormGroup>

        <FormGroup name="password_confirmation" label="Password">
            <Input
                ref="password_confirmation"
                name="password_confirmation"
                type="password"
                v-model="form.password_confirmation"
                required
                autocomplete="new-password"/>
        </FormGroup>

        <div class="flex items-center justify-end mt-4">
            <SubmitButton
                :submitting="form.processing"
                :disabled="form.errors.any()">
                Reset Password
            </SubmitButton>
        </div>
    </form>
</template>

<script>
import FormGroup from "@/Components/Form/FormGroup";
import Input from "@/Components/Form/Input";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    name: "ResetPasswordForm",

    props: {
        token: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            form: this.$form({
                token: this.token,
                email: this.email,
                password: '',
                password_confirmation: '',
            })
        }
    },

    emits: ['success'],

    provide() {
        return {
            form: this.form
        };
    },

    components: {
        FormGroup,
        Input,
        SubmitButton,
    },

    methods: {
        focus() {
            this.$refs.password.focus();
        },
        submit() {
            this.form.post(route('password.update'))
                .then(({message}) => {
                    this.$notify.success(message);
                    this.$emit('success')
                })
        }
    }
}
</script>
